module.exports = __webpack_public_path__ + "img/iphone15proMax.0d06645d.png";